var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunSliderElement_instances, _DuoyunSliderElement_orientation_get, _DuoyunSliderElement_max_get, _DuoyunSliderElement_step_get, _DuoyunSliderElement_diff_get, _DuoyunSliderElement_getValue, _DuoyunSliderElement_onPan, _DuoyunSliderElement_onEnd, _DuoyunSliderElement_setPrecisionValue, _DuoyunSliderElement_onKeydown, _DuoyunSliderElement_onInputChange;
// https://spectrum.adobe.com/page/slider/
import { adoptedStyle, customElement, attribute, globalemitter, emitter, boolattribute, numattribute, refobject, } from '@mantou/gem/lib/decorators';
import { GemElement, html } from '@mantou/gem/lib/element';
import { createCSSSheet, css, classMap } from '@mantou/gem/lib/utils';
import { theme } from '../lib/theme';
import { clamp } from '../lib/number';
import { hotkeys } from '../lib/hotkeys';
import { focusStyle } from '../lib/styles';
import './gesture';
import './input';
const style = createCSSSheet(css `
  :host {
    font-size: 0.875em;
    width: 15em;
    --size: 1em;
    --c: calc(var(--size) / 2 + 6px);
    display: inline-flex;
    align-items: center;
    gap: 1em;
    height: calc(2.2em + 2px);
  }
  .slider {
    flex-grow: 1;
    position: relative;
    height: 2px;
    border-radius: 1px;
  }
  .mark {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10em;
    box-sizing: border-box;
    width: var(--size);
    height: var(--size);
    border: 2px solid;
    transition: border-width 0.1s;
    opacity: 0.8;
  }
  .mark:hover {
    opacity: 1;
  }
  :host(:focus-visible) .mark,
  .mark.start {
    border-width: 5px;
  }
  :host([disabled]) .mark {
    cursor: not-allowed;
    background: ${theme.disabledColor};
  }
  .label,
  .value {
    position: absolute;
    font-size: 0.875em;
    bottom: calc(50% + var(--size) / 2 + 0.5em);
    color: ${theme.describeColor};
  }
  .value {
    right: 0;
  }
  .input {
    width: 50px;
  }
`);
/**
 * @customElement dy-slider
 */
let DuoyunSliderElement = class DuoyunSliderElement extends GemElement {
    constructor() {
        super();
        _DuoyunSliderElement_instances.add(this);
        this.state = {
            position: 0,
            displayPosition: 0,
            start: false,
        };
        _DuoyunSliderElement_getValue.set(this, (precisionValue) => {
            const remainder = precisionValue % __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_step_get);
            const rest = Math.round(remainder / __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_step_get)) * __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_step_get);
            return precisionValue - remainder + rest;
        });
        _DuoyunSliderElement_onPan.set(this, ({ detail, target }) => {
            if (this.disabled)
                return;
            const { width, height } = this.sliderRef.element.getBoundingClientRect();
            const { left, right, top, bottom, width: w, height: h } = target.getBoundingClientRect();
            const isV = __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_orientation_get) === 'vertical';
            const totalLength = isV ? height - h : width - w;
            const center = (isV ? top + bottom : left + right) / 2;
            const current = isV ? detail.clientY : detail.clientX;
            const movement = isV ? detail.y : detail.x;
            if (movement < 0 && current > center)
                return;
            if (movement > 0 && current < center)
                return;
            const position = clamp(0, this.state.position + movement / totalLength, 1);
            const precisionValue = position * __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_diff_get);
            const value = __classPrivateFieldGet(this, _DuoyunSliderElement_getValue, "f").call(this, precisionValue);
            this.setState({ position });
            this.change(value);
        });
        _DuoyunSliderElement_onEnd.set(this, () => {
            this.setState({ start: false });
            this.end(this.value);
        });
        _DuoyunSliderElement_setPrecisionValue.set(this, (precisionValue) => {
            const value = __classPrivateFieldGet(this, _DuoyunSliderElement_getValue, "f").call(this, clamp(this.min, precisionValue, __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_max_get)));
            const position = value / __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_diff_get);
            this.setState({ position, displayPosition: position });
            this.change(value);
        });
        _DuoyunSliderElement_onKeydown.set(this, hotkeys({
            up: () => __classPrivateFieldGet(this, _DuoyunSliderElement_setPrecisionValue, "f").call(this, this.value + 1),
            down: () => __classPrivateFieldGet(this, _DuoyunSliderElement_setPrecisionValue, "f").call(this, this.value - 1),
        }));
        _DuoyunSliderElement_onInputChange.set(this, (evt) => {
            evt.stopPropagation();
            __classPrivateFieldGet(this, _DuoyunSliderElement_setPrecisionValue, "f").call(this, evt.detail);
        });
        this.render = () => {
            const { displayPosition, start } = this.state;
            const position = `calc(var(--size) / 2 + calc(100% - var(--size)) * ${displayPosition})`;
            return html `
      <style>
        .slider {
          background: radial-gradient(
            circle at ${position},
            transparent,
            transparent var(--c),
            ${theme.borderColor} var(--c)
          );
        }
        .mark {
          left: ${position};
        }
      </style>
      <div class="slider" ref=${this.sliderRef.ref}>
        <dy-gesture
          class=${classMap({ mark: true, start })}
          @pan=${__classPrivateFieldGet(this, _DuoyunSliderElement_onPan, "f")}
          @pointerdown=${() => !this.disabled && this.setState({ start: true })}
          @end=${__classPrivateFieldGet(this, _DuoyunSliderElement_onEnd, "f")}
        ></dy-gesture>
        ${this.label
                ? html `
              <div class="label">${this.label}</div>
              <div class="value">${this.value}</div>
            `
                : ''}
      </div>
      ${this.editable
                ? html `
            <dy-input
              ?disabled=${this.disabled}
              class="input"
              type="number"
              value=${String(this.value)}
              @change=${__classPrivateFieldGet(this, _DuoyunSliderElement_onInputChange, "f")}
            ></dy-input>
          `
                : ''}
    `;
        };
        this.tabIndex = 0;
        this.addEventListener('keydown', __classPrivateFieldGet(this, _DuoyunSliderElement_onKeydown, "f"));
        this.internals.role = 'slider';
        this.effect(() => {
            this.internals.ariaDisabled = String(this.disabled);
            this.internals.ariaValueText = String(this.value);
            const position = __classPrivateFieldGet(this, _DuoyunSliderElement_getValue, "f").call(this, clamp(this.min, this.value, __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_max_get))) / __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_diff_get);
            this.setState({ position, displayPosition: position });
        }, () => [this.value, this.disabled]);
    }
};
_DuoyunSliderElement_getValue = new WeakMap(), _DuoyunSliderElement_onPan = new WeakMap(), _DuoyunSliderElement_onEnd = new WeakMap(), _DuoyunSliderElement_setPrecisionValue = new WeakMap(), _DuoyunSliderElement_onKeydown = new WeakMap(), _DuoyunSliderElement_onInputChange = new WeakMap(), _DuoyunSliderElement_instances = new WeakSet(), _DuoyunSliderElement_orientation_get = function _DuoyunSliderElement_orientation_get() {
    return this.orientation || 'horizontal';
}, _DuoyunSliderElement_max_get = function _DuoyunSliderElement_max_get() {
    return this.hasAttribute('max') ? this.max : 100;
}, _DuoyunSliderElement_step_get = function _DuoyunSliderElement_step_get() {
    return this.step || 1;
}, _DuoyunSliderElement_diff_get = function _DuoyunSliderElement_diff_get() {
    return __classPrivateFieldGet(this, _DuoyunSliderElement_instances, "a", _DuoyunSliderElement_max_get) - this.min;
};
__decorate([
    attribute
], DuoyunSliderElement.prototype, "label", void 0);
__decorate([
    attribute
], DuoyunSliderElement.prototype, "orientation", void 0);
__decorate([
    boolattribute
], DuoyunSliderElement.prototype, "editable", void 0);
__decorate([
    boolattribute
], DuoyunSliderElement.prototype, "disabled", void 0);
__decorate([
    refobject
], DuoyunSliderElement.prototype, "sliderRef", void 0);
__decorate([
    numattribute
], DuoyunSliderElement.prototype, "value", void 0);
__decorate([
    numattribute
], DuoyunSliderElement.prototype, "min", void 0);
__decorate([
    numattribute
], DuoyunSliderElement.prototype, "max", void 0);
__decorate([
    numattribute
], DuoyunSliderElement.prototype, "step", void 0);
__decorate([
    globalemitter
], DuoyunSliderElement.prototype, "change", void 0);
__decorate([
    emitter
], DuoyunSliderElement.prototype, "end", void 0);
DuoyunSliderElement = __decorate([
    customElement('dy-slider'),
    adoptedStyle(style),
    adoptedStyle(focusStyle)
], DuoyunSliderElement);
export { DuoyunSliderElement };
//# sourceMappingURL=slider.js.map